<app-portal-detail-drawer
    variant="task"
    drawerTitle="Invoice Details"
    [resetScrollKey]="selectedInvoice?.id"
    [hideTopbar]="isInvoicePreviewFullscreen"
    (backClick)="closeInvoiceDetailDrawer()"
    (closeClick)="closeInvoiceDetailDrawer()">
    <ng-container *ngIf="(loading$ | async) === false && selectedInvoice; else invoiceShellLoader">
        <form #editInvoice="ngForm" class="invoice-redesign" (change)="editInvoice.control.markAsTouched()">
            <div #formTop></div>

            <div class="invoice-redesign__header">
                <div class="invoice-redesign__title">
                    <span>INVOICE</span>
                    <strong>#{{ selectedInvoice?.invoiceNumber || editInvoiceDetails?.invoiceNumber || '-' }}</strong>
                    <span
                        class="invoice-status-pill"
                        [ngClass]="'invoice-status-pill--' + invoiceStatusClass(selectedInvoice?.status)"
                        *ngIf="selectedInvoice?.status">
                        <mat-icon>{{ invoiceStatusIcon(selectedInvoice?.status) }}</mat-icon>
                        {{ invoiceStatusLabel(selectedInvoice?.status) }}
                    </span>
                </div>
                <div class="invoice-redesign__actions">
                    <button
                        type="button"
                        class="pill-action"
                        *ngIf="(selectedInvoice?.status == 'new' || selectedInvoice?.status === 'draft') && (editMode$ | async) == false"
                        (click)="toggleEditCancelMode(true)">
                        <mat-icon>edit</mat-icon>
                        <span>Edit</span>
                    </button>
                    <button
                        type="button"
                        class="pill-action danger"
                        *ngIf="(selectedInvoice?.status !== 'paid' && selectedInvoice?.status !== 'canceled' && selectedInvoice?.status !== 'deleted' && selectedInvoice?.status !== 'partially_paid') && !((selectedInvoice?.status == 'new' || selectedInvoice?.status == 'draft') && (editMode$ | async))"
                        (click)="deleteDialog()">
                        <mat-icon>delete_outline</mat-icon>
                        <span>Delete</span>
                    </button>
                    <button type="button" class="pill-action" (click)="handleRejectInvoice()" *ngIf="selectedInvoice?.status === 'in_review'">
                        <mat-icon>close</mat-icon>
                        <span>Reject</span>
                    </button>
                    <button type="button" class="pill-action" (click)="toggleEditCancelMode(false)" *ngIf="(selectedInvoice?.status == 'draft' || selectedInvoice?.status == 'new') && (editMode$ | async)">
                        <span>Cancel</span>
                    </button>
                    <button type="button" class="pill-action primary" (click)="handleApproveInvoice()" *ngIf="selectedInvoice?.status === 'in_review'">
                        <mat-icon>check</mat-icon>
                        <span>Approve</span>
                    </button>
                    <button
                        type="button"
                        class="pill-action primary"
                        (click)="handleApproveInProgress()"
                        [disabled]="sumOfcategoryAmount() !== 0"
                        *ngIf="selectedInvoice?.status === 'new' && (editMode$ | async) == false">
                        <span>Submit</span>
                    </button>
                    <button type="button" class="pill-action primary" *ngIf="selectedInvoice?.status === 'ready_for_payment' || selectedInvoice?.status === 'partially_paid'" (click)="handlePayInvoice()">
                        <span>Make payment</span>
                    </button>
                    <button
                        type="button"
                        class="pill-action primary"
                        *ngIf="((selectedInvoice?.status === 'new' || selectedInvoice?.status === 'draft') && (editMode$ | async))"
                        (click)="selectedInvoice?.status === 'draft' ? onSaveConfirmation() : onSaveInvoice()"
                        [disabled]="editInvoiceDetails.categoryAmountDifference !== 0">
                        <span>Save</span>
                    </button>
                </div>
                <div class="breadcrumb-row">
                    <span>Fund Operation</span>
                    <span>/</span>
                    <span>Invoices</span>
                    <span>/</span>
                    <strong>invoice_{{ selectedInvoice?.invoiceNumber || editInvoiceDetails?.invoiceNumber || '-' }}</strong>
                </div>
            </div>

            <div class="invoice-review-banner" *ngIf="invoiceBannerMessage(selectedInvoice?.status) as bannerMessage">
                <mat-icon>error_outline</mat-icon>
                <span>
                    <strong *ngIf="selectedInvoice?.status === 'new' || selectedInvoice?.status === 'draft'">OCR Pre-fill - review required.</strong>
                    {{ bannerMessage }}
                </span>
            </div>

            <div class="invoice-document-card invoice-document-card--compact" *ngIf="getDocumentUrl">
                <div class="invoice-document-card__file">
                    <span class="pdf-icon">PDF</span>
                    <div>
                        <strong>{{ invoiceDocumentName }}</strong>
                        <span>Uploaded document</span>
                    </div>
                </div>
                <button
                    type="button"
                    class="invoice-document-card__expand"
                    (click)="isInvoicePreviewFullscreen ? closeInvoicePreview() : openInvoicePreview()"
                    [attr.aria-label]="isInvoicePreviewFullscreen ? 'Close invoice preview' : 'Open invoice preview'">
                    <mat-icon>{{ isInvoicePreviewFullscreen ? 'close_fullscreen' : 'open_in_full' }}</mat-icon>
                </button>
            </div>

            <app-portal-detail-section
                title="Invoice details"
                [open]="isSectionOpen('invoice')"
                (toggle)="toggleSection('invoice')">
                <div class="invoice-form-grid">
                    <div class="invoice-field half">
                        <mat-label>Invoice Type <span>*</span></mat-label>
                        <mat-form-field appearance="fill">
                            <mat-select
                                name="type"
                                #invoiceType
                                [(ngModel)]="editInvoiceDetails.type"
                                (ngModelChange)="onInvoiceTypeChange($event)"
                                required
                                disableRipple="true"
                                placeholder="Select type"
                                [panelClass]="'select-invoice-type'"
                                [disabled]="(editMode$ | async) == false">
                                <mat-option [value]="'inbound'">Inbound</mat-option>
                                <mat-option [value]="'outbound'">Outbound</mat-option>
                            </mat-select>
                            <mat-icon matSuffix>keyboard_arrow_down</mat-icon>
                        </mat-form-field>
                    </div>

                    <div class="invoice-field half">
                        <mat-label>Invoice Number <span>*</span></mat-label>
                        <mat-form-field appearance="fill">
                            <input
                                matInput
                                [(ngModel)]="editInvoiceDetails.invoiceNumber"
                                [disabled]="(editMode$ | async) == false"
                                name="invoiceNumber"
                                type="text"
                                required>
                        </mat-form-field>
                    </div>

                    <div class="invoice-field half">
                        <mat-label>Issue Date</mat-label>
                        <mat-form-field appearance="fill">
                            <input
                                matInput
                                [matDatepicker]="issueDatePicker"
                                [(ngModel)]="editInvoiceDetails.issueDate"
                                name="issueDate"
                                [disabled]="(editMode$ | async) == false"
                                (click)="issueDatePicker.open()">
                            <mat-datepicker #issueDatePicker></mat-datepicker>
                            <mat-datepicker-toggle matSuffix [for]="issueDatePicker"></mat-datepicker-toggle>
                        </mat-form-field>
                    </div>

                    <div class="invoice-field half">
                        <mat-label>Due Date</mat-label>
                        <mat-form-field appearance="fill">
                            <input
                                matInput
                                [matDatepicker]="dueDatePicker"
                                [(ngModel)]="editInvoiceDetails.dueDate"
                                name="dueDate"
                                [disabled]="(editMode$ | async) == false"
                                (click)="dueDatePicker.open()">
                            <mat-datepicker #dueDatePicker></mat-datepicker>
                            <mat-datepicker-toggle matSuffix [for]="dueDatePicker"></mat-datepicker-toggle>
                        </mat-form-field>
                    </div>

                    <div class="invoice-field full">
                        <mat-label>Service Period <span>*</span></mat-label>
                        <mat-form-field appearance="fill" class="service-date-range">
                            <mat-date-range-input [rangePicker]="pickerServiceDate" [disabled]="(editMode$ | async) == false">
                                <input matStartDate placeholder="Start date" [(ngModel)]="editInvoiceDetails.servicePeriodStart" name="servicePeriodStart" />
                                <input matEndDate placeholder="End date" [(ngModel)]="editInvoiceDetails.servicePeriodEnd" name="servicePeriodEnd" />
                            </mat-date-range-input>
                            <mat-date-range-picker #pickerServiceDate></mat-date-range-picker>
                            <mat-datepicker-toggle matIconSuffix [for]="pickerServiceDate"></mat-datepicker-toggle>
                        </mat-form-field>
                    </div>

                    <div class="invoice-field full">
                        <mat-label>Currency <span>*</span></mat-label>
                        <mat-form-field appearance="fill">
                            <input matInput [(ngModel)]="editInvoiceDetails.currency" name="currency" disabled type="text">
                        </mat-form-field>
                    </div>
                </div>
            </app-portal-detail-section>

            <app-portal-detail-section
                title="Supplier Information"
                [open]="isSectionOpen('supplier')"
                (toggle)="toggleSection('supplier')">
                <div class="invoice-form-grid">
                    <div class="invoice-field full">
                        <mat-label>Supplier Name <span>*</span></mat-label>
                        <input class="invoice-read-field" type="text" [value]="supplierName()" readonly>
                    </div>
                    <div class="invoice-field half">
                        <mat-label>VAT ID</mat-label>
                        <input class="invoice-read-field" type="text" [value]="supplierVatId()" readonly>
                    </div>
                    <div class="invoice-field half">
                        <mat-label>Tax Number</mat-label>
                        <input class="invoice-read-field muted" type="text" [value]="supplierTaxNumber()" readonly>
                    </div>
                    <div class="invoice-field full">
                        <mat-label>Address</mat-label>
                        <input class="invoice-read-field" type="text" [value]="supplierAddress()" readonly>
                    </div>
                    <div class="invoice-field full">
                        <mat-label>Email</mat-label>
                        <input class="invoice-read-field" type="text" [value]="supplierEmail()" readonly>
                    </div>
                    <div class="invoice-field full">
                        <mat-label>Phone</mat-label>
                        <input class="invoice-read-field" type="text" [value]="supplierPhone()" readonly>
                    </div>
                </div>
            </app-portal-detail-section>

            <app-portal-detail-section
                title="Counterparty details"
                [open]="isSectionOpen('counterparty')"
                (toggle)="toggleSection('counterparty')">
                <div class="invoice-form-grid">
                    <div class="invoice-field full">
                        <mat-label>Company Name <span>*</span></mat-label>
                        <mat-form-field appearance="fill">
                            <input matInput [(ngModel)]="counterPartyName" [disabled]="(editMode$ | async) == false" name="counterparty" type="text" required>
                        </mat-form-field>
                    </div>
                    <div class="invoice-field full">
                        <mat-label>IBAN <span>*</span></mat-label>
                        <mat-form-field appearance="fill">
                            <input matInput [(ngModel)]="editBankAccount.iban" name="iban" [disabled]="(editMode$ | async) == false" type="text" required>
                        </mat-form-field>
                    </div>
                    <div class="invoice-field full">
                        <mat-label>SWIFT/BIC <span>*</span></mat-label>
                        <mat-form-field appearance="fill">
                            <input matInput [(ngModel)]="editBankAccount.bic" name="bic" [disabled]="(editMode$ | async) == false" type="text" required>
                        </mat-form-field>
                    </div>
                    <div class="invoice-field half">
                        <mat-label>Customer Number</mat-label>
                        <input class="invoice-read-field" type="text" [value]="counterpartyCustomerNumber()" readonly>
                    </div>
                    <div class="invoice-field half">
                        <mat-label>VAT ID</mat-label>
                        <input class="invoice-read-field muted" type="text" [value]="counterpartyVatId()" readonly>
                    </div>
                    <div class="invoice-field full">
                        <mat-label>Address</mat-label>
                        <input class="invoice-read-field" type="text" [value]="counterpartyAddress()" readonly>
                    </div>
                </div>
            </app-portal-detail-section>

            <app-portal-detail-section
                title="Categorization"
                [open]="isSectionOpen('categorization')"
                (toggle)="toggleSection('categorization')">
                <div class="invoice-form-grid categorization-fields">
                    <div class="invoice-field full">
                        <mat-label>Total Amount Including Tax <span>*</span></mat-label>
                        <mat-form-field appearance="fill">
                            <input
                                matInput
                                type="number"
                                appPreventInputFieldScroll
                                [(ngModel)]="editInvoiceDetails.totalAmount"
                                (ngModelChange)="onCategoryItemChange(); calculateOutsourceAmount()"
                                name="totalamount"
                                [disabled]="(editMode$ | async) == false"
                                required>
                        </mat-form-field>
                    </div>

                    <ng-container *ngFor="let item of editCategorizationItem; let i = index">
                        <div class="category-split-card">
                            <button
                                class="category-remove-btn"
                                type="button"
                                (click)="removeCatergoryItem(i)"
                                [disabled]="editCategorizationItem.length == 1 || (editMode$ | async) == false"
                                aria-label="Remove category">
                                <mat-icon>delete_outline</mat-icon>
                            </button>
                            <div class="invoice-field full">
                                <mat-label>Category <span>*</span></mat-label>
                                <mat-form-field appearance="fill">
                                    <mat-select
                                        name="category{{ i }}"
                                        [panelClass]="'custom-category-panel'"
                                        (openedChange)="clearSearch(i)"
                                        [(ngModel)]="item.category"
                                        #categoryPanel
                                        required
                                        disableRipple="true"
                                        (ngModelChange)="onCategoryItemChange()"
                                        placeholder="Select type"
                                        [disabled]="item.disabled">
                                        <div class="category-search-field">
                                            <mat-form-field id="categorySearchInput" class="search-input-box">
                                                <img src="../../assets/images/search.svg" alt="search" matPrefix />
                                                <input
                                                    matInput
                                                    type="text"
                                                    [(ngModel)]="searchQueries[i]"
                                                    (ngModelChange)="onSearchChange(i, $event)"
                                                    (keydown.space)="$event.stopPropagation()"
                                                    [ngModelOptions]="{ standalone: true }"
                                                    class="search-input-box" />
                                            </mat-form-field>
                                        </div>
                                        <mat-optgroup *ngFor="let group of filteredCategoriesMap[i]" [label]="group.type" class="search-category">
                                            <mat-option class="closing-name-option" *ngFor="let subItem of group.items" [value]="subItem">
                                                {{ subItem.name }}
                                            </mat-option>
                                        </mat-optgroup>
                                    </mat-select>
                                    <mat-icon matSuffix>keyboard_arrow_down</mat-icon>
                                </mat-form-field>
                            </div>

                            <div class="invoice-field half">
                                <mat-label>Tax Type <span>*</span></mat-label>
                                <mat-form-field appearance="fill">
                                    <mat-select
                                        name="taxtype{{ i }}"
                                        [(ngModel)]="item.taxValue"
                                        required
                                        disableRipple="true"
                                        (ngModelChange)="onCategoryItemChange()"
                                        [disabled]="item.disabled"
                                        placeholder="Select">
                                        <mat-option class="closing-name-option" *ngFor="let tax of taxType" [value]="tax.value">
                                            {{ tax.label }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-icon matSuffix>keyboard_arrow_down</mat-icon>
                                </mat-form-field>
                            </div>

                            <div class="invoice-field half">
                                <mat-label>Total Amount <span>*</span></mat-label>
                                <mat-form-field appearance="fill">
                                    <input
                                        matInput
                                        [(ngModel)]="item.amount"
                                        name="amount{{ i }}"
                                        type="number"
                                        appPreventInputFieldScroll
                                        (ngModelChange)="onCategoryItemChange()"
                                        required
                                        [disabled]="item.disabled">
                                </mat-form-field>
                            </div>
                        </div>
                    </ng-container>

                    <button class="add-category-btn redesign" type="button" (click)="onAddCategorizationItem()" [disabled]="(editMode$ | async) == false">
                        <mat-icon>add_circle_outline</mat-icon>
                        <span>Add new category</span>
                    </button>

                    <mat-accordion class="invoice-difference-accordion">
                        <mat-expansion-panel class="transation-expanssion">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <span>Total difference in amount</span>
                                    <strong>{{ (editInvoiceDetails.categoryAmountDifference | number : '1.2' | convertWithDecimal:selectedVehicle:false:false:'') || '0.00' }}</strong>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="invoice-difference-row">
                                <span>Transaction amount</span>
                                <strong>{{ (editInvoiceDetails.totalAmount | number : '1.2' | convertWithDecimal:selectedVehicle:false:false:'') || '0.00' }}</strong>
                            </div>
                            <div class="invoice-difference-row">
                                <span>Sum of splits (Includes VAT)</span>
                                <strong>{{ (editInvoiceDetails.totalCategoryAmount | number : '1.2' | convertWithDecimal:selectedVehicle:false:false:'') || '0.00' }}</strong>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>

                    <ng-container *ngIf="showErrorTransaction(editInvoiceDetails?.outstandingAmount)">
                        <div class="transaction-warning-container">
                            <img src="../../../../assets/images/warning_icon.svg" height="20px" width="20px" alt="icon" />
                            <span>The linked transaction exceeds the total invoice amount. Please link the right transaction to submit the invoice.</span>
                        </div>
                    </ng-container>

                    <div class="linked-transaction-card" *ngFor="let transaction of linkedTransationLists">
                        <mat-icon>account_balance</mat-icon>
                        <div>
                            <strong>Invoice #{{ transaction.transactionCode || transaction.transactionId }} Payment</strong>
                            <span>{{ transaction.bookingDate ? commonService.formateDate(transaction.bookingDate) : 'Uploaded just now' }}</span>
                        </div>
                        <strong class="linked-transaction-card__amount">
                            {{ ((transaction.amount) | number : '1.2' | convertWithDecimal:selectedVehicle:false:false:'') + ' €' }}
                        </strong>
                        <button type="button" (click)="unLinkInvoiceDailog(transaction.transactionId)">
                            <mat-icon>link_off</mat-icon>
                        </button>
                    </div>

                    <div class="unlink-details" *ngIf="linkedTransationLists.length == 0">
                        Link a transaction to this invoice to reconcile
                    </div>

                    <button
                        class="link-transaction-dropzone"
                        type="button"
                        (click)="linkTransactionPopup()"
                        [disabled]="selectedInvoice?.status === 'deleted' || selectedInvoice?.status === 'rejected' || (selectedInvoice?.status === 'draft' && (editMode$ | async) == false)">
                        <mat-icon>link</mat-icon>
                        <span>Link a transaction to this invoice</span>
                    </button>
                </div>
            </app-portal-detail-section>

            <app-portal-detail-section
                title="Payments"
                *ngIf="selectedInvoice?.payments && selectedInvoice.payments.length > 0"
                [open]="isSectionOpen('payments')"
                (toggle)="toggleSection('payments')">
                <span portalDetailSectionMeta class="section-count">{{ selectedInvoice.payments.length }}</span>
                <div class="invoice-payment-list">
                    <button class="invoice-payment-card" type="button" *ngFor="let payment of paymentsDataSource.data" (click)="handleShowInvoicePayment(payment.id)">
                        <mat-icon>qr_code_2</mat-icon>
                        <div>
                            <strong>{{ payment.reference }}</strong>
                            <span>{{ payment.paidAt }}</span>
                        </div>
                        <strong class="invoice-payment-card__amount">
                            {{ ((payment.amount) | number : '1.2' | convertWithDecimal:selectedVehicle:false:false:'') + ' €' }}
                        </strong>
                        <span class="invoice-payment-card__status">{{ payment.status }}</span>
                    </button>
                </div>
            </app-portal-detail-section>

            <app-portal-detail-section
                title="Attachments"
                [open]="isSectionOpen('attachments')"
                (toggle)="toggleSection('attachments')">
                <span portalDetailSectionMeta class="section-count">1</span>
                <div class="attachment-card" *ngIf="getDocumentUrl">
                    <span class="pdf-icon">PDF</span>
                    <div>
                        <strong>{{ invoiceDocumentName }}</strong>
                        <span>Uploaded document</span>
                    </div>
                    <a [href]="getDocumentUrl" target="_blank" rel="noopener" aria-label="Download attachment">
                        <mat-icon>download</mat-icon>
                    </a>
                </div>
            </app-portal-detail-section>

            <app-portal-detail-section
                title="Activity History"
                [open]="isSectionOpen('activity')"
                (toggle)="toggleSection('activity')">
                <div class="activity-history-list" *ngIf="invoiceLogsData.length; else noInvoiceActivity">
                    <div class="activity-history-item" *ngFor="let historyData of invoiceLogsData">
                        <span class="activity-avatar">{{ ((historyData?.user?.firstName || '') + ' ' + (historyData?.user?.lastName || '')).trim() || (historyData?.user?.email || 'System') | intialsName }}</span>
                        <div>
                            <strong>{{ commonService.getDisplayName(historyData) || 'System' }}</strong>
                            <span>{{ getLabelsByAction(historyData.action).updatedDateLabel }} {{ commonService.getDateFormatWithTime(historyData?.createdAt, true) }}</span>
                        </div>
                    </div>
                </div>
                <ng-template #noInvoiceActivity>
                    <div class="empty-activity">No activity yet.</div>
                </ng-template>
            </app-portal-detail-section>

            <app-portal-detail-section
                title="Comments"
                [open]="isSectionOpen('comments')"
                (toggle)="toggleSection('comments')">
                <div class="invoice-comments-redesign">
                    <div class="invoice-comment-compose">
                        <span class="activity-avatar">{{ userName | intialsName }}</span>
                        <textarea class="comment-text-area" [formControl]="commentControl" placeholder="Add a comment..."></textarea>
                    </div>
                    <div class="comment-actions" *ngIf="commentControl.value?.trim()">
                        <button type="button" class="comment-action cancel" (click)="cancelCommentForm()" [disabled]="saveCommentLoading">Cancel</button>
                        <button type="button" class="comment-action save" (click)="saveCommentForm()" [disabled]="saveCommentLoading">Save</button>
                    </div>
                    <div
                        class="comments-list"
                        (scroll)="onTableScroll($event)"
                        [ngClass]="{ 'comments-list--with-compose-actions': commentControl.value?.trim() }"
                        *ngIf="!commentLoading; else commentLoader">
                        <div class="invoice-comment-item" *ngFor="let comment of commentList">
                            <span class="activity-avatar">{{ ((comment?.user?.firstName || '') + ' ' + (comment?.user?.lastName || '')).trim() || (comment?.user?.email || '') | intialsName }}</span>
                            <div>
                                <div class="comment-first-row">
                                    <strong>{{ commonService.getDisplayName(comment) }}</strong>
                                    <span>{{ comment.createdAt | timeago }}</span>
                                </div>
                                <p>{{ comment.commentText }}</p>
                            </div>
                        </div>
                        <div class="empty-activity" *ngIf="commentList.length === 0">No comments yet.</div>
                    </div>
                    <ng-template #commentLoader>
                        <ngx-skeleton-loader count="3" appearance="line" [theme]="{ height: '20px', marginBottom: '16px' }"></ngx-skeleton-loader>
                    </ng-template>
                    <div class="comment-scroll-loader" *ngIf="scrollCommnetLoading">
                        <img src="../../../../assets/images/lazy_loading_spinner.svg" alt="spiner-loader" />
                    </div>
                </div>
            </app-portal-detail-section>

            <div class="invoice-totals">
                <div>
                    <span>Subtotal</span>
                    <strong>{{ (editInvoiceDetails.subTotal ? (editInvoiceDetails.subTotal | number : '1.2' | convertWithDecimal:selectedVehicle:false:false:'') : '0') + ' €' }}</strong>
                </div>
                <div>
                    <span>VAT total</span>
                    <strong>{{ (editInvoiceDetails.vatTotal ? (editInvoiceDetails.vatTotal | number : '1.2' | convertWithDecimal:selectedVehicle:false:false:'') : '0') + ' €' }}</strong>
                </div>
                <div>
                    <span>Total</span>
                    <strong>{{ (editInvoiceDetails.totalAmount ? (editInvoiceDetails.totalAmount | number : '1.2' | convertWithDecimal:selectedVehicle:false:false:'') : '0') + ' €' }}</strong>
                </div>
                <div class="outstanding">
                    <span>Outstanding</span>
                    <strong>{{ (editInvoiceDetails?.outstandingAmount ? (editInvoiceDetails?.outstandingAmount | number : '1.2' | convertWithDecimal:selectedVehicle:false:false:'') : '0') + ' €' }}</strong>
                </div>
            </div>

            <div class="invoice-footer-actions portal-detail-sticky-actions">
                <button class="cancel" type="button" (click)="toggleEditCancelMode(false)" *ngIf="(editMode$ | async)">Cancel</button>
                <button class="cancel" type="button" (click)="closeInvoiceDetailDrawer()" *ngIf="(editMode$ | async) == false">Cancel</button>
                <button
                    class="submit"
                    type="button"
                    *ngIf="((selectedInvoice?.status === 'new' || selectedInvoice?.status === 'draft') && (editMode$ | async))"
                    (click)="selectedInvoice?.status === 'draft' ? onSaveConfirmation() : onSaveInvoice()"
                    [disabled]="editInvoiceDetails.categoryAmountDifference !== 0">
                    Save
                </button>
                <button
                    class="submit"
                    type="button"
                    *ngIf="selectedInvoice?.status === 'new' && (editMode$ | async) == false"
                    (click)="handleApproveInProgress()"
                    [disabled]="sumOfcategoryAmount() !== 0">
                    Submit
                </button>
                <button class="submit" type="button" *ngIf="selectedInvoice?.status === 'in_review'" (click)="handleApproveInvoice()">Approve</button>
                <button class="submit" type="button" *ngIf="selectedInvoice?.status === 'ready_for_payment' || selectedInvoice?.status === 'partially_paid'" (click)="handlePayInvoice()">Make payment</button>
            </div>
        </form>
    </ng-container>
</app-portal-detail-drawer>

<div class="invoice-fullscreen-preview" *ngIf="isInvoicePreviewFullscreen">
    <div class="invoice-fullscreen-preview__topbar">
        <button type="button" class="invoice-fullscreen-preview__round-btn" (click)="closeInvoicePreview()">
            <mat-icon>chevron_left</mat-icon>
        </button>
        <span>Invoice Details</span>
        <button type="button" class="invoice-fullscreen-preview__round-btn" (click)="closeInvoiceDetailDrawer()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="invoice-fullscreen-preview__content">
        <div class="invoice-fullscreen-preview__document">
            <app-pdf-apryse
                *ngIf="getDocumentUrl"
                [filePath]="getDocumentUrl"
                [fileName]="invoiceDocumentName"
                [isShowAnnotation]="false">
            </app-pdf-apryse>
        </div>
    </div>
</div>

<app-qrcode
    [qrCodeBase64]="qrCodeData.qrcode"
    [metaData]="qrCodeData.embeddedMetaData"
    [isReadyOnly]="isQrCodeReadOnly"
    [status]="selectedInvoice.status"
    (closeQrCodeEvent)="closeQrCode()"
    (markAsPaidEvent)="markAsPaid()"
    *ngIf="showQrCode$ | async">
</app-qrcode>

<app-payment-input
    [invoiceData]="selectedInvoice"
    [selectedVehicle]="selectedVehicle"
    (closePaymentInputEvent)="closePaymentInput()"
    (proceedToPaymentEvent)="handlePaymentProceed($event)"
    *ngIf="showPaymentInput$ | async">
</app-payment-input>

<div class="main-loader" *ngIf="mainLoader$ | async">
    <mat-spinner class="spinner"></mat-spinner>
</div>

<ng-template #invoiceShellLoader>
    <div class="invoice-redesign invoice-redesign--loading">
        <ngx-skeleton-loader count="8" appearance="line" [theme]="{ height: '44px', marginBottom: '14px' }"></ngx-skeleton-loader>
    </div>
</ng-template>
